import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Strukturdaten.FooterAbsatz
 * abschliessendes Dokument - z.B. Folgen bei Verletzungen von Obliegenheiten
 * Endpoints: /api/v2/versicherungen/fahrrad/v2/schaden
 */
export class FooterAbsatzApi extends BaseApiModel {
	constructor(initialProperties?: Partial<FooterAbsatzApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected title: string;
	/**
	 * Description: Titel des Footer
	 * APIL Type: string
	 */
	get Title(): string {
		return this.title;
	}

	/**
	 * Description: Titel des Footer
	 * APIL Type: string
	 */
	set Title(value: string) {
		this.title = value;
	}

	protected text: string;
	/**
	 * Description: Text des Footer
	 * APIL Type: string
	 */
	get Text(): string {
		return this.text;
	}

	/**
	 * Description: Text des Footer
	 * APIL Type: string
	 */
	set Text(value: string) {
		this.text = value;
	}

	protected zusatzText: string;
	/**
	 * Description: Text mit den rechtlichen und sonstigen Hinweise bei den Checkboxen
	 * APIL Type: string
	 */
	get ZusatzText(): string {
		return this.zusatzText;
	}

	/**
	 * Description: Text mit den rechtlichen und sonstigen Hinweise bei den Checkboxen
	 * APIL Type: string
	 */
	set ZusatzText(value: string) {
		this.zusatzText = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): FooterAbsatzApi {
		return AppUtils.Helper.createFromMap(dataObject, FooterAbsatzApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Title = this.title;
		result.Text = this.text;
		result.ZusatzText = this.zusatzText;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}